"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var HfilterAction_1 = require("@/pages/search/actions/HfilterAction");
var React = require("react");
var react_redux_1 = require("react-redux");
var mapStateToProps = function (state) { return (__assign({}, state.hfilter)); };
var mapDispatchToProps = function (dispatch) { return ({
    onSortOptionClicked: function (option) { return dispatch(HfilterAction_1.default.onSortOptionClicked(option)); },
    closeSortPanel: function () { return dispatch(HfilterAction_1.default.setSortOpen(false)); },
}); };
var hfilterSort = function (props) {
    var renderSortOption = function (option, index) {
        var onClick = function () { return props.onSortOptionClicked(option); };
        return (React.createElement("li", { key: index },
            React.createElement("a", { onClick: onClick }, option.name)));
    };
    return (React.createElement("div", { className: "l-fullscreen-dim " + (props.sortFullActive ? 'l-fullscreen-dim--active' : '') },
        React.createElement("div", { className: "c-hfiltersort" },
            React.createElement("div", { className: "c-hfiltersort__top" },
                React.createElement("button", { onClick: props.closeSortPanel, className: "c-navbar__back" },
                    React.createElement("span", { className: "fal fa-chevron-left" }),
                    " ",
                    props.t.back)),
            React.createElement("ul", null, props.sortOptions.map(renderSortOption)))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(hfilterSort);
